import React, { Component, Fragment } from 'react'
import StockDisplayProvider from './StockDisplayProvider'
import StockInputsProvider from './StockInputsProvider'
import StockTableProvider from './StockTableProvider'

export default class StockFormProvider extends Component {
	componentDidMount() {
		this.props.clearStoreStockProvider()
	}

	componentWillUnmount = () => {
		const { confirmedStock, handleCancelApi } = this.props
		if (confirmedStock === null) {
			handleCancelApi()
		}
	}

	render() {
		const { idOperacion, referenceItem, params } = this.props
		return (
			<Fragment>
				<StockDisplayProvider
					handleCancelStock={this.props.handleCancelStock}
					handleConfirmStock={this.props.handleConfirmStock}
				/>
				<StockInputsProvider
					idOperacion={idOperacion}
					referenceItem={referenceItem}
					handleSetErrorBarCode={this.props.handleSetErrorBarCode}
					params={params}
				/>
				<StockTableProvider handleChangeTable={this.props.handleChangeTable} />
			</Fragment>
		)
	}
}
